export { BirthdaysPageModule } from './birthdays-page.module';
export { BirthdaysPageComponent } from './birthdays-page.component';
